export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=60c30fd51817c7c4c29ec76d58d7234dce26462cbd&name=getProductServerAction!'